import { render, staticRenderFns } from "./ready.vue?vue&type=template&id=2da969c4&"
import script from "./ready.vue?vue&type=script&lang=ts&"
export * from "./ready.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports